import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";
import * as util from "../../shared/src/util";

export const CallbackPreference1 = union([
    literal("as_soon_as_possible"),
    literal("morning"),
    literal("afternoon"),
    literal("early_evening"),
]);
export type TCallbackPreference1Codec = typeof CallbackPreference1;
export type TCallbackPreference1 = TTypeOfCodec<TCallbackPreference1Codec>;

export const CallbackPreference1_DisplayString = (preference: TCallbackPreference1): string =>
    preference === "as_soon_as_possible" ? "As soon as you can"
    : preference === "morning" ? "Morning"
    : preference === "afternoon" ? "Afternoon"
    : preference === "early_evening" ? "Early evening"
    : util.requireExhaustive(preference);
